var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row nftmax-gap-30"},[_c('div',{staticClass:"col-lg-6 col-12 nftmax-sixth-one"},[_c('SellHistoryWidget')],1),_c('div',{staticClass:"col-lg-6 col-12 nftmax-sixth-two"},[_c('TopSellCountryWidget')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }